import { Target, Lightbulb, Handshake } from 'lucide-react';

const highlights = [
  {
    icon: Target,
    title: 'Foco estratégico',
    description:
      'Pensamos antes de construir. Cada solução nasce de uma análise profunda do seu negócio.',
  },
  {
    icon: Lightbulb,
    title: 'Inovação com propósito',
    description:
      'Tecnologia a serviço de resultados reais, não apenas tendências do mercado.',
  },
  {
    icon: Handshake,
    title: 'Parceria de verdade',
    description:
      'Trabalhamos lado a lado com você, com transparência e comunicação clara.',
  },
];

export function About() {
  return (
    <section id="sobre" className="py-20 lg:py-28">
      <div className="mx-auto max-w-6xl px-6">
        <div className="grid gap-12 lg:grid-cols-2 lg:gap-16 items-center">
          <div>
            <p className="text-sm font-semibold uppercase tracking-widest text-accent">
              Sobre a Limiar
            </p>
            <h2 className="mt-3 font-heading text-3xl font-bold tracking-tight text-foreground sm:text-4xl text-balance">
              O ponto de virada digital do seu negócio
            </h2>
            <p className="mt-6 leading-relaxed text-muted-foreground">
              <strong className="text-foreground">Limiar</strong> significa o ponto de
              transição, a linha entre o antes e o depois. É exatamente nisso que
              acreditamos: ajudar empresas a atravessarem a barreira entre processos
              manuais, ineficientes ou fragmentados e soluções digitais modernas,
              seguras e escaláveis.
            </p>
            <p className="mt-4 leading-relaxed text-muted-foreground">
              Nossa abordagem é consultiva. Antes de escrever uma linha de código,
              entendemos o seu problema, mapeamos oportunidades e desenhamos a
              estratégia certa para o seu contexto.
            </p>
          </div>

          <div className="grid gap-6">
            {highlights.map((item) => (
              <div
                key={item.title}
                className="flex gap-4 rounded-xl border border-border bg-card p-5 transition-colors hover:border-accent/40"
              >
                <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-accent/10">
                  <item.icon className="h-5 w-5 text-accent" />
                </div>
                <div>
                  <h3 className="font-heading text-sm font-semibold text-foreground">
                    {item.title}
                  </h3>
                  <p className="mt-1 text-sm leading-relaxed text-muted-foreground">
                    {item.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
